import React from 'react'
import { withPrefix } from 'gatsby'
import * as styles from './styles.module.scss'

/**
 */
const Container = ({ children }) => {
  return <div className={styles.Container}>{children}</div>
}

/**
 */
const Copyright = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${withPrefix('/images/layout/icon_footer.png')})`,
      }}
      className={styles.BackGround}
    >
      <p className={styles.Copyright}>
        Copyright ©️2021-2022 LOGLOG CO.,Ltd. All Rights Reserved. Licensed to
        Marubeni Arch-LOG Co.,Ltd.
      </p>
    </div>
  )
}

/**
 */
export const Content = () => {
  return (
    <Container>
      <Copyright />
    </Container>
  )
}
